import { IOrderProduct } from '~/types/orders';
import { IMenuProduct } from '~/types/products';

export const getProductMainPrice = (product: IMenuProduct | IOrderProduct): number => {
  return product.size && product.size.id ? product.size.price : product.price;
};
